<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px" class="customer-menu">
            <el-row>
                <el-radio-group v-model="config[field.key]">
                <span v-for="item in radioList" class="radio-item">
                    <el-radio :label="item.value">{{item.label}}</el-radio>
                </span>
                </el-radio-group>
            </el-row>
        </el-form-item>
    </div>
</template>

<style lang="scss">
    .radio-item{
        padding-right: 20px;
    }
</style>

<script>
  export default {
    name: 'tms-type-custom-menu',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        radioList: [{
          label: "展示图标隐藏文案",
          value: 1
        },{
          label: "不展示图标",
          value: 0
        }]
      }
    },

    computed: {
    },

    components: {
    },

    mounted() {
    },

    methods: {
      
    }
  }

</script>
